"use client";

import { ComposedSelect } from "#/ui/select";

export interface RegionOption {
  label: string;
  value: string;
}

export const DEFAULT_REGION_OPTIONS: RegionOption[] = [
  { label: "EU 🇪🇺", value: "eu" },
  { label: "US 🇺🇸", value: "us" },
  { label: "AU 🇦🇺", value: "au" },
];

/**
 * Presentational region switcher. Purely `value`/`onChange` — the caller
 * (`components/switch-region-select.tsx`) owns reading the current region
 * (`useCurrentRegion()`) and deciding what happens on change (cross-subdomain
 * redirect).
 */
export const RegionSelect = ({
  value,
  options = DEFAULT_REGION_OPTIONS,
  onChange,
  className = "bg-card",
}: {
  value: string;
  options?: RegionOption[];
  onChange: (value: string) => void;
  className?: string;
}) => {
  return (
    <ComposedSelect
      value={value}
      className={className}
      onChange={onChange}
      data={options}
      hideSearch
    />
  );
};
